import { FC } from 'react';
import { Button, Spinner } from "react-bootstrap";
import { t } from 'i18next';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowsRotate } from '@fortawesome/free-solid-svg-icons';

interface IProps {
  onClick: (event: any) => Promise<void>;
  isLoading?: boolean;
  disabled?:boolean;
}

const ButtonReload: FC<IProps> = ({
  onClick,
  isLoading,
  disabled,
}) => {
  return (
    <Button
      type="button"
      onClick={(e) => onClick(e)}
      disabled={disabled || false}
    >
      {isLoading &&
        <Spinner
          as="span"
          animation="border"
          size="sm"
          role="status"
          aria-hidden="true"
        />
      }
      <FontAwesomeIcon icon={faArrowsRotate} className='me-2' />
      <span>{t("EQUIPMENT.RECALCULATE_FORECAST")}</span>
    </Button>
  );
}

export default ButtonReload;